define('lq/events/actions/cqCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function CQCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(CQCommand, EventAction);

    CQCommand.typeName = 'CQCommand';

    CQCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    CQCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'CQCommand',
            command: this.eventData.command
        };
    };

    return CQCommand;
});
